export default __webpack_public_path__ + "static/BgImage-aacfa6dfcdef8db4acc0ae419815bb05.png";